import { gql } from '@apollo/client'
import { ID } from '../../utils/id'

export interface CompanySettingFragment {
  id: ID
  name: string
  value: string
  fileReadUrl: string
  created: string
  updated: string
}

export const COMPANY_SETTING_FRAGMENT = gql`
  fragment CompanySetting on CompanySetting {
    id
    name
    value
    fileReadUrl
    created
    updated
  }
`
